import appState from "_src/app_state";
import TrackballControl from "_src/client/controls/trackball";
import OrbitControl from "_src/client/controls/orbit";
import output from "_src/engine/output";
import PhotoControl from "_src/client/controls/photo_control";

export default {
  createControl(type, camera) {
    switch (type) {
      case appState.CC_TRACKBALL:
        return new TrackballControl(camera);
      case appState.CC_ORBIT:
        return new OrbitControl(camera);
      case appState.CC_PHOTO:
        return new PhotoControl(camera);
      default:
        output.error(output.DEVELOPERS_ERROR, "Can't create camera control. Unknown type: " + type);
    }
  }
}
